import React, { Component } from 'react';
import { SelectButton as SelectButtonPrime } from 'primereact/components/selectbutton/SelectButton';
import './SelectButton.styles';

class SelectButton extends Component {
  onChange = ({ value }) => {
    this.props.onChange(value);
  };

  render() {
    const {
      options,
      placeholder,
      onChange,
      value,
      readOnly,
      ...rest
    } = this.props;
    return (
      <SelectButtonPrime
        {...rest}
        disabled={readOnly}
        value={value}
        options={options || []}
        onChange={this.onChange}
        unselectable={true}
      />
    );
  }
}

export default SelectButton;



// WEBPACK FOOTER //
// ./src/components/inputs/selectbutton/SelectButton.js